import { FC, MouseEvent, useEffect } from 'react';
import { LocalTournament } from 'react-easyrocket';
import { tournamentsStorageApi } from '../../storageApi';

import img from './img/localTournament.webp';
import { useNavigate } from 'react-router';
import { PrizePoolTournament } from 'src/components/Tournaments/PrizePoolTournament';
import { CloseIcon } from './img/CloseIcon';
import { useNotifiacationLocalTournamentStore } from 'src/store';

interface TournamentNotificationPopUpProps {
  tournament: LocalTournament;
}

export const TournamentNotificationPopUp: FC<TournamentNotificationPopUpProps> = ({
  tournament
}) => {
  const navigate = useNavigate();
  const { setNewTournament } = useNotifiacationLocalTournamentStore();

  useEffect(() => {
    tournamentsStorageApi.markAsShown(tournament.id);
  }, [tournament.id]);

  const closeNotification = () => {
    setNewTournament(null);
    tournamentsStorageApi.markAsClosed(tournament.id);
  };

  const navigateToTournament = () => {
    navigate(`/tournaments/local/${tournament.id}`);
    closeNotification();
  };

  const onCloseButtonClick = (e: MouseEvent) => {
    e.stopPropagation();
    closeNotification();
  };

  return (
    <div onClick={navigateToTournament} className="top-0 right-0 w-full h-[50px] z-[1000]">
      <div className="bg-LOCAL_TOURNAMENT_NOTIFICATION_BG w-full text-sm h-full flex justify-between text-mg_text items-center">
        <img src={img} height="50" width="92" alt="Tournament logo" className="h-full w-fit" />
        <div className="flex-1">
          <p className="line-clamp-1 text-sm font-normal">{tournament.name}</p>
          <PrizePoolTournament
            tournament={tournament}
            className="font-bold text-sm line-clamp-1"
            isTournamentNotification
          />
        </div>
        <button className="px-3" onClick={onCloseButtonClick} aria-label="Close notification">
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};
